import React from 'react';

import { ButtonCategory, Dropdown, RadioGroup, useI18n } from '@freelancelabs/components';
import { GlobeOutline } from '@freelancelabs/icons';

interface Props {
    /**
     * L'habillage du bouton, qui depend du FOND sur lequel il est pose (PCG-304).
     *
     * `inverse` sur l'aparte, dont l'aplat est `--portal-accent` : un bouton encre en bleu de
     * marque y serait invisible. `weak` reste le defaut, pour le fond clair de la colonne de
     * gauche, seul endroit ou le commutateur se rend en dessous de 900 px.
     */
    category?: ButtonCategory;
}

const LanguageSwitcher = ({ category = 'weak' }: Props) => {
    const { changeLocale, localeCode, availableLocales } = useI18n();

    /**
     * We don't want to display language switcher if there is not or only one available language.
     */
    const shouldDisplay = Object.keys(availableLocales).length > 1;

    const content = (
        <>
            <GlobeOutline /> <span className="truncate">{availableLocales[localeCode]}</span>
        </>
    );

    const options = Object.keys(availableLocales).map((value) => ({
        value,
        label: availableLocales[value],
    }));

    return (
        <>
            {shouldDisplay && (
                <Dropdown content={content} buttonCategory={category}>
                    <RadioGroup
                        className="px-2"
                        category="check"
                        value={localeCode}
                        options={options}
                        onValue={changeLocale}
                    />
                </Dropdown>
            )}
        </>
    );
};

export default LanguageSwitcher;
